import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { MoreVertical, Share, AlertTriangle, Heart } from 'lucide-react';
import { ReportErrorDialog } from './ReportErrorDialog';
import { useFavorites } from '@/hooks/useFavorites';
interface PodcastMenuButtonProps {
  podcastName: string;
  className?: string;
}
export const PodcastMenuButton: React.FC<PodcastMenuButtonProps> = ({
  podcastName,
  className = ""
}) => {
  const [showReportDialog, setShowReportDialog] = useState(false);
  const {
    addToFavorites,
    removeFromFavorites,
    favorites,
    isFavorite
  } = useFavorites();
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: podcastName,
        text: `Écoutez ce podcast : ${podcastName}`,
        url: window.location.href
      });
    } else {
      // Fallback pour les navigateurs qui ne supportent pas l'API Web Share
      navigator.clipboard.writeText(window.location.href);
      // Vous pouvez ajouter un toast ici pour notifier l'utilisateur
    }
  };
  const handleToggleFavorite = () => {
    if (isFavorite(podcastName)) {
      removeFromFavorites(podcastName);
    } else {
      addToFavorites(podcastName);
    }
  };
  return <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className={`h-8 w-8 p-0 hover:bg-muted/50 ${className}`} onClick={e => e.stopPropagation()}>
            <MoreVertical className="h-4 w-4" />
            <span className="sr-only">Ouvrir le menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem onClick={handleShare}>
            <Share className="mr-2 h-4 w-4" />
            Partager
          </DropdownMenuItem>
          
          <DropdownMenuItem onClick={() => setShowReportDialog(true)}>
            <AlertTriangle className="mr-2 h-4 w-4" />
            Signaler une erreur
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ReportErrorDialog open={showReportDialog} onOpenChange={setShowReportDialog} podcastName={podcastName} />
    </>;
};